// Pure pricing helpers for the reprice review queue (and mirror of the Edit
// modal's price/compare-at rules, kept here so the two never drift).

// Pounds string -> integer pence, or null when blank/invalid.
export function toPence(str) {
  if (str == null || String(str).trim() === '') return null
  const n = Number.parseFloat(str)
  if (!Number.isFinite(n)) return null
  return Math.round(n * 100)
}

// Integer pence -> 2dp pounds string, '' for null.
export function toPounds(cents) {
  return cents == null ? '' : (cents / 100).toFixed(2)
}

// "Round down to the next £x9.00": the largest whole-pound value <= the price
// that ends in £9 (e.g. £25 -> £19, £30 -> £29, £129 -> £129). Sub-£9 prices
// have no lower £x9 and are left unchanged. Null in -> null out.
export function roundDownToX9(cents) {
  if (cents == null) return null
  const pounds = Math.floor(cents / 100)
  const tens = Math.floor(pounds / 10) * 10
  const candidate = tens + 9
  const out = candidate <= pounds ? candidate : tens - 1
  return out >= 9 ? out * 100 : cents
}

// Client mirror of the server block: a non-blank compare-at must not be below
// the new price (compare-at is the "was" price; it can't be under the sale price).
export function isCompareAtBlocked(priceCents, compareAtCents) {
  return compareAtCents != null && priceCents != null && priceCents > compareAtCents
}

// Absolute fractional price change from current; null when current is missing/zero.
export function swingPct(currentCents, newCents) {
  if (!currentCents || newCents == null) return null
  return Math.abs(newCents - currentCents) / currentCents
}

// Compact "10 Jul 14:22" for a last-repriced timestamp; em-dash when absent.
// Backend sends a UTC ISO string; shown in local time. Shared by the Pricing
// Management column and the reprice review overlay so they read identically.
export function formatLastRepriced(ts) {
  if (!ts) return '—'
  const d = new Date(ts)
  if (Number.isNaN(d.getTime())) return '—'
  return `${d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })} ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
}
